import styled from 'styled-components';
import { BREAKPOINTS } from 'styles/media';

interface ShareBarLikeCTAWrapperProps {
  liked: boolean;
}

export const ShareBarLikeCTAWrapper = styled.div<ShareBarLikeCTAWrapperProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;

  ${({ liked }) =>
    liked
      ? `
    &:hover {
      & > .liked > path {
        fill: #C9523B;
      }
    }
  `
      : `
    
  `}

  padding: 4px 8px;
  cursor: pointer;

  position: relative;
`;

export const ShareBarLikeCTAText = styled.span`
  font-weight: 500;
  font-size: 14px;
  font-style: normal;
  line-height: normal;

  color: var(--color-text);

  user-select: none;

  ${BREAKPOINTS.tablet} {
    text-align: center;
  }
`;
